var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackside(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 67,
    rx: 4,
    fill: "#CBCBCB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45.5,
    width: 21,
    height: 15,
    rx: 3,
    fill: "#F7F7F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24.5,
    width: 21,
    height: 15,
    rx: 3,
    fill: "#F7F7F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 29.5,
    width: 43,
    height: 4,
    rx: 2,
    fill: "#F7F7F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 40.5,
    width: 43,
    height: 4,
    rx: 2,
    fill: "#F7F7F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 7.5,
    width: 81,
    height: 11,
    rx: 3,
    fill: "#F7F7F7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 51.5,
    width: 43,
    height: 4,
    rx: 2,
    fill: "#F7F7F7"
  })));
}

export default SvgBackside;